import Cookies from 'js-cookie'

const getConsent = (cookieName: string) => Cookies.get(cookieName) === 'True'

type CookieConsent = {
  allCookiesAccepted: boolean
  cookieCategoryPreferences: {
    consentCookieFunctional: boolean
    consentCookieMarketing: boolean
    consentCookieNecessary: boolean
    consentCookieStatistic: boolean
  }
}

const getCookieConsent = (): CookieConsent => {
  const consent = {
    cookieCategoryPreferences: {
      consentCookieFunctional: getConsent('Marketing'),
      consentCookieMarketing: getConsent('Functional'),
      consentCookieNecessary: true,
      consentCookieStatistic: getConsent('Statistical'),
    },
  }

  return { ...consent, allCookiesAccepted: Object.values(consent.cookieCategoryPreferences).every(Boolean) }
}

export default getCookieConsent
